// extracted by mini-css-extract-plugin
export var deleteModal = "_ry-0";